import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getServerSyncedTime } from '../../../utils/TimeUtils';
import { useExamRulesState } from '../examsStores';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RetakeExamButton = ({
  cooldownHourCount = 12,
  use,
  withTooltip,
  mostRecentExamAttempt,
  ctaText
}) => {
  const {
    setShowExamRules
  } = useExamRulesState();
  const isInCooldown = mostRecentExamAttempt && mostRecentExamAttempt.attemptRetakeTime > getServerSyncedTime();
  const button = /*#__PURE__*/_jsx(Button, {
    disabled: !!isInCooldown,
    onClick: () => setShowExamRules(true),
    use: use,
    children: ctaText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.retakeButton"
    })
  });
  if (isInCooldown) {
    if (withTooltip) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.exams.rules.cooldownHourDurationCount",
          options: {
            cooldownHourCount
          }
        }),
        children: button
      });
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [button, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.exams.rules.cooldownHourDurationCount",
            options: {
              cooldownHourCount
            }
          })
        })]
      });
    }
  }
  return button;
};
export default RetakeExamButton;